export default {
  en: [
    { label: 'ptbs', violation: 'Pretending to Be Someone' },
    {
      label: 'nsfw',
      violation: 'Posting Inappropriate Things (Nudity, Sex, Drugs, Hate, Violence)',
    },
    { label: 'faac', violation: 'Fake Account' },
    { label: 'hack', violation: 'User Seems Hacked' },
    { label: 'smth', violation: 'Something Else' },
  ],
  it: [
    { label: 'ptbs', violation: 'Fingendo Di Essere Qualcuno' },
    {
      label: 'nsfw',
      violation: 'Pubblicare Cose Inappropriate (Nudità, Sesso, Droghe, Odio, Violenza)',
    },
    { label: 'faac', violation: 'Account Falso' },
    { label: 'hack', violation: "L'utente Sembra Violato" },
    { label: 'smth', violation: "Qualcos'altro" },
  ],
};
